import loc, { format } from 'owa-localize';
import { emptySpinButtonLabel } from '../CapabilityFilters.locstring.json';

const CAPACITYVALUEFORMAT = '{0}+';
const PLUS = '+';

// for capacity values which are string values like "any" or other user input strings, return "Any";
// for values <= 0 also return "Any";
// for values between 0 and maxCapacity of current room list, return the formated value like "x+";
// for all other values greater than maxCapacity, return formated max capacity.
export function getAdjustedCapacityString(capacityToValidate: string, maxCapacity: number) {
    capacityToValidate = removeCapacitySuffixIfNeeded(capacityToValidate);
    const capacityValue = Number(capacityToValidate);
    if (!capacityValue || capacityValue <= 0) {
        return loc(emptySpinButtonLabel);
    } else if (capacityValue > maxCapacity) {
        capacityToValidate = maxCapacity.toString();
    }

    // display capacity value in "x+" format, where "x" is the validated capacity value
    return format(CAPACITYVALUEFORMAT, capacityToValidate);
}

export function removeCapacitySuffixIfNeeded(capacityValue: string): string {
    if (!hasCapacitySuffix(capacityValue)) {
        return capacityValue;
    }

    return capacityValue.substr(0, capacityValue.length - 1);
}

function hasCapacitySuffix(capacityValue: string): boolean {
    return capacityValue.substr(capacityValue.length - 1) === PLUS;
}

// check if the default or updated floor value is valid, if valid then update "selectedFloor" in store;
// otherwise adjust the value to either "any" or maxFloor accordingly:
// if the value is not numeric or smaller than minFloor of current room list, return "Any";
// if the value is between minFloor and maxFloor, then just return the value;
// otherwise if the value is greater than maxFloor, return maxFloor so that it's within range.
export function getAdjustedFloorString(
    floorToValidate: string,
    maxFloor: number,
    minFloor: number
) {
    if (!floorToValidate || floorToValidate === loc(emptySpinButtonLabel) || !isFinite(minFloor)) {
        return loc(emptySpinButtonLabel);
    }

    const floor = Number(floorToValidate);

    // when user input is neither number nor "any", it's considered as invalid and should be converted to default "any" value
    if (!floor || floor < minFloor) {
        floorToValidate = loc(emptySpinButtonLabel);
    } else if (floor > maxFloor) {
        floorToValidate = maxFloor.toString();
    }

    return floorToValidate;
}
